import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, ShoppingBag, User, Heart, LogOut } from '../../lib/lucide-proxy';
import { useAuth } from '../../contexts/AuthContext';

const UserSidebar = () => {
  const location = useLocation();
  const { signOut } = useAuth();

  const navigation = [
    { name: 'Dashboard', href: '/dashboard', icon: LayoutDashboard },
    { name: 'Meus Pedidos', href: '/dashboard/orders', icon: ShoppingBag },
    { name: 'Favoritos', href: '/dashboard/favorites', icon: Heart },
    { name: 'Meu Perfil', href: '/dashboard/profile', icon: User },
  ];

  const isActive = (path) => {
    if (path === '/dashboard' && location.pathname === '/dashboard') return true;
    if (path !== '/dashboard' && location.pathname.startsWith(path)) return true;
    return false;
  };

  return (
    <div className="hidden md:flex flex-col w-64 bg-white border-r border-gray-200 min-h-screen">
      <div className="flex items-center justify-center h-16 border-b border-gray-200">
        <Link to="/" className="flex items-center space-x-2">
          <div className="w-8 h-8 bg-primary-500 rounded-lg flex items-center justify-center">
            <span className="text-white font-bold text-sm">C</span>
          </div>
          {/* BRANDING UPDATE */}
          <span className="font-display font-bold text-xl text-dark-900">
            Cerveja <span className="text-primary-500">Delivery</span>
          </span>
        </Link>
      </div>
      
      <div className="flex-1 overflow-y-auto py-4">
        <nav className="px-2 space-y-1">
          {navigation.map((item) => (
            <Link
              key={item.name}
              to={item.href}
              className={`group flex items-center px-2 py-2 text-sm font-medium rounded-md transition-colors ${
                isActive(item.href)
                  ? 'bg-primary-50 text-primary-600'
                  : 'text-dark-600 hover:bg-gray-50 hover:text-dark-900'
              }`}
            >
              <item.icon
                className={`mr-3 h-5 w-5 flex-shrink-0 ${
                  isActive(item.href) ? 'text-primary-500' : 'text-dark-400 group-hover:text-dark-500'
                }`}
              />
              {item.name}
            </Link>
          ))}
        </nav>
      </div>
      
      <div className="border-t border-gray-200 p-4">
        <button 
          onClick={() => signOut()}
          className="flex items-center w-full px-2 py-2 text-sm font-medium text-red-600 rounded-md hover:bg-red-50 transition-colors"
        >
          <LogOut className="mr-3 h-5 w-5" />
          Sair
        </button>
      </div>
    </div>
  );
};

export default UserSidebar;